import React, { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  Outlet,
  createRoutesFromElements,
  Route,
  Link,
} from "react-router-dom";
import Contact from "../../components/Contact/Contact";
import Meeting from "../../scenes/Meeting";
import MeetingTabsContainer from "../../scenes/Meeting/LComponents/TabsContainer/MeetingTabsContainer";
import AlignmentMeeting from "../../scenes/AlignmentMeeting/Index";
import Tenants from "../../scenes/Tenants/Tenants";
import CompanyTeams from "../../scenes/CompanyTeams/CompanyTeams";
import MyCompanyTeams from "../../scenes/CompanyTeams/MyCompanyTeams";
import AlignmentCompany from "../../scenes/CompanyTeams/AlignmentCompany";
import { AuthProvider } from "../../Context/AuthProvider";
import {
  RequierAuth,
  ReqPhone,
} from "../../components/RequierAuth/RequierAuth";
import { useSelector } from "react-redux";
import Kr from "../../scenes/OKRManagment/LComponents/KR/Kr";
import TeamDetail from "../../scenes/CompanyTeams/LComponents/TeamDetail/TeamDetail";
// import Profile from "../../scenes/CompanyManagment/Copmonents/Profile/Profile";
import OverView from "../../scenes/OverView/OverView";

import LoginPage from "../../components/Login/LoginPage";
import Dashboard from "../../components/Dashboard";

import OkrManagmentContainer from "../../scenes/OKRManagment";
import CompanyManagment from "../../scenes/CompanyManagment";
import NotFoundPage from "../../components/NotFoundPage/NotFoundPage";
import Settings from "../../scenes/Settings/Setting";
import Aboutus from "../../scenes/Aboutus/Index";
import Reports from "../../scenes/Reports/ShowVerticalAlignment";
import AllTenantOkrs from "../../scenes/AllTenantOkrs/Index";
import OKRTree from "../../scenes/OKRTree/Index";
import VerticalAlignmentPage from "../../scenes/VerticalAlignmentPage/Index";
import VerticalAlignmentTree from "../../scenes/VerticalAlignmentTree/Index";
import IndexManagment from "../../scenes/IndexManagment/Index";
import IndexManaging from "../../scenes/IndexManaging/Index";
import Helpsoftware from "../../scenes/Helpsoftware/Index";
import ReleaseNotesTitle from "../../scenes/Helpsoftware/ReleaseNotesTitle";
import TenantDash from "../../scenes/TenantDash/Index";
import IndexBank from "../../scenes/IndexBank/Index";
import MissionAndStrategy from "../../scenes/MissionAndStrategy/Index";
import MissionAndStrategyMap from "../../scenes/MissionAndStrategyMap/Index";
import Profile from "../../scenes/CompanyManagment/Copmonents/Profile/Profile";
import Chatpage from "../../scenes/Chat/Chatpage";
import InviteUser from "../../scenes/CompanyManagment/Copmonents/InviteUser/InviteUser";
import TenantInfo from "../../scenes/CompanyManagment/Copmonents/TenantInfo/TenantInfo";
import User
 from "../../scenes/CompanyManagment/User";
// const OkrManagmentContainer = lazy(() => import("../../scenes/OKRManagment"));
// const CompanyManagment = lazy(() => import("../../scenes/CompanyManagment"));
// const NotFoundPage = lazy(
//   () => import("../../components/NotFoundPage/NotFoundPage")
// );
// const Settings = lazy(() => import("../../scenes/Settings/Setting"));
// const Aboutus = lazy(() => import("../../scenes/Aboutus/Index"));
// const Reports = lazy(() => import("../../scenes/Reports/ShowVerticalAlignment"));
// const AllTenantOkrs = lazy(() => import("../../scenes/AllTenantOkrs/Index"));
// const VerticalAlignmentPage = lazy(() => import("../../scenes/VerticalAlignmentPage/Index"));
// const IndexManagment = lazy(() => import("../../scenes/IndexManagment/Index"));
// const IndexManaging = lazy(() => import("../../scenes/IndexManaging/Index"));
// const Helpsoftware = lazy(() => import("../../scenes/Helpsoftware/Index"));
// const TenantDash = lazy(() => import("../../scenes/TenantDash/Index"));
// const IndexBank = lazy(() => import("../../scenes/IndexBank/Index"));
// const MissionAndStrategy = lazy(() => import("../../scenes/MissionAndStrategy/Index"));
// const Profile = lazy(
//   () => import("../../scenes/CompanyManagment/Copmonents/Profile/Profile")
// );
const Mrouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<LoginPage />} />

      <Route
        path="/companyTeams"
        element={
          <RequierAuth>
            <CompanyTeams />
          </RequierAuth>
        }
      />
        <Route
        path="/myCompanyTeams"
        element={
          <RequierAuth>
            <MyCompanyTeams />
          </RequierAuth>
        }
      />
      <Route
        path="/alignmentCompanyTeams"
        element={
          <RequierAuth>
            <AlignmentCompany />
          </RequierAuth>
        }
      />
    
      <Route
        path="/dashboard"
        element={
          <RequierAuth>
            <Dashboard />
          </RequierAuth>
        }
      >
        <Route path="/dashboard/meetings" element={<MeetingTabsContainer />} />
        <Route
          path="/dashboard/tenants"
          element={
            <ReqPhone>
              <Tenants />
            </ReqPhone>
          }
        />

        <Route path="/dashboard/alignmentMeeting" element={<AlignmentMeeting />} />
        <Route
          path="/dashboard/tenants"
          element={
            <ReqPhone>
              <Tenants />
            </ReqPhone>
          }
        />

        <Route
          path="/dashboard/VerticalAlignmentPage"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <VerticalAlignmentPage />
              </RequierAuth>
            </Suspense>
          }
        />
        
        <Route
          path="/dashboard/VerticalAlignmentTree"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <VerticalAlignmentTree />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/indexManagment"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <IndexManagment />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/indexManaging"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <IndexManaging />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/AllTenantokrs"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <AllTenantOkrs />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/OKRTree"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <OKRTree />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/okrManagment"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <OkrManagmentContainer />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/report"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Reports />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/IndexBank"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <IndexBank />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/MissionAndStrategyMap"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <MissionAndStrategyMap />
              </RequierAuth>
            </Suspense>
          }
        />      

        <Route
          path="/dashboard/MissionAndStrategy"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <MissionAndStrategy />
              </RequierAuth>
            </Suspense>
          }
        />
        <Route
          path="/dashboard/companyManagment"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <CompanyManagment />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/companyManagment/profile"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Profile />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/aboutus"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Aboutus />
              </RequierAuth>
            </Suspense>
          }
        />
                <Route
          path="/dashboard/chat"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Chatpage />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/Helpsoftware/index"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Helpsoftware />
              </RequierAuth>
            </Suspense>
          }
        />
        <Route
          path="/dashboard/Helpsoftware/ReleaseNotesTitle"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <ReleaseNotesTitle />
              </RequierAuth>
            </Suspense>
          }
        />
        <Route
          index
          path="/dashboard/TenantDash"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <TenantDash />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/okrManagment/objectiveDetails"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <Kr />
              </RequierAuth>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/companyManagment/teamDetails"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <TeamDetail />
              </RequierAuth>
            </Suspense>
          }
        />
                <Route
          path="/dashboard/companyManagment/User"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <RequierAuth>
                <User/>
              </RequierAuth>
            </Suspense>
          }
        />

        {/* OkrManagmentContainer */}
        {/* <Route  element={<OverView/>} /> */}

        {/* <Route path="/dashboard/contact"  element={<Contact/>} /> */}

        <Route
          path="*"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <NotFoundPage />
            </Suspense>
          }
        />        
        <Route
          path="/dashboard/InviteUser"
          element={
          <Suspense fallback={<div>درحال بارگزاری...</div>}>
            <InviteUser />
          </Suspense>
        }
      />
              <Route
          path="/dashboard/TenantInfo"
          element={
          <Suspense fallback={<div>درحال بارگزاری...</div>}>
            <TenantInfo />
          </Suspense>
        }
      />

        <Route
          path="/dashboard/settings"
          element={
            <Suspense fallback={<div>درحال بارگزاری...</div>}>
              <Settings />
            </Suspense>
          }
        />
      </Route>
      
    </>
  )
);

export default Mrouter;
